export const REGIME_MODAL_TEXTS = {
  title: 'Conoce más de los regímenes',
  closeLabel: 'Cerrar',
  intro: '¿En qué consiste?',
};

export interface IRegimeHighlightPart {
  text: string;
  strong: boolean;
}

export interface IRegimeModalTab {
  id: string;
  label: string;
  bullets: string[];
  highlight: IRegimeHighlightPart[];
  note: string;
}

export const REGIME_MODAL_TABS: IRegimeModalTab[] = [
  {
    id: 'A',
    label: 'Régimen A',
    bullets: [
      'El régimen A es un beneficio estatal que permite aumentar tu pensión, dado que el Estado te deposita anualmente el 15% de los aportes realizados en el año, con un tope de 6 UTM',
      'La rentabilidad de los giros que pertenecen al régimen A, están sujetos a pago de impuestos cuando es mayor a 30 UTM anuales.',
    ],
    highlight: [
      {
        text: 'Si ahorras $1.000.000 anual, el Estado te bonifica $150.000 (15%), dejando tu ahorro en $1.150.000',
        strong: true,
      },
      {
        text: ', a esto se le suma la rentabilidad de la AFP el periodo de la inversión según el o los fondos que elijas.',
        strong: false,
      },
    ],
    note: 'Considera que, en caso de que retires dinero se descontará el 15% por concepto de bonificación fiscal.',
  },
  {
    id: 'B',
    label: 'Régimen B',
    bullets: [
      'El régimen B es un beneficio tributario que permite rebajar la base imponible, por lo que de forma anual o mensual se disminuyen los impuestos a pagar.',
      'Tiene un tope de 50 UF mensuales y 600 UF anuales.',
      'Al inicio del año siguiente, podrás descargar un certificado con todos los movimientos realizados en tu APV, para los efectos de la Declaración de Impuestos a la Renta.',
    ],
    highlight: [
      {
        text: 'Si tu renta imponible es de $2.100.000 y ahorras $300.000 mensuales, disminuirás tu base tributable a $1.800.000, por lo que ahorrarás $288.000',
        strong: true,
      },
      {
        text: ' en impuestos al año.',
        strong: false,
      },
    ],
    note: 'Si retiras los fondos APV acogidos al Régimen B antes de pensionarte, se retendrá un 15% del monto retirado como anticipo del Impuesto Único.',
  },
];
